import React from 'react';
import { motion } from 'framer-motion';

export default function PageContainer({ children, title }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4 }}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
    >
      {title && (
        <div className="mb-10 text-center">
          <h1 className="text-5xl md:text-6xl font-display text-transparent bg-clip-text bg-gradient-to-r from-sun-yellow to-white inline-block drop-shadow-lg">
            {title}
          </h1>
          <div className="w-24 h-1 bg-sun-yellow mx-auto mt-4 mb-2 rounded-full"></div>
          <p className="subtitle-typewriter text-gray-400 text-sm">AUTHENTIC & RAW</p>
        </div>
      )}
      <div className="glass-panel p-6 md:p-10">
        {children}
      </div>
    </motion.div>
  );
}